import { ColorRadioGroupSkeleton, FormLayout, Skeleton } from "src/components"

export const CustomRoofColorSkeleton = () => (
	<FormLayout>
		<Skeleton.Input withLabel />
		<Skeleton.Input withLabel />
		<ColorRadioGroupSkeleton count={5} />
		<Skeleton.Input withLabel />
	</FormLayout>
)
